var _style, _ellipse, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActuatorLevelPoweredbyLiquidLevel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 4.4,
    cy: 9.2,
    rx: 3.8,
    ry: 2.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.4,
    y1: 6.8,
    x2: 4.4,
    y2: 4.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.1,
    y1: 9.2,
    x2: 8.9,
    y2: 9.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 9.2,
    x2: 11.1,
    y2: 9.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.2,
    y1: 9.2,
    x2: 13.4,
    y2: 9.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.4,
    y1: 9.2,
    x2: 15.6,
    y2: 9.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActuatorLevelPoweredbyLiquidLevel);
export default __webpack_public_path__ + "static/media/ActuatorLevelPoweredbyLiquidLevel.5109f6b14284c348e834d8038fa3fd2b.svg";
export { ForwardRef as ReactComponent };